module.exports = __webpack_public_path__ + "media/images/players/MICKELSON_PHIL-ea318246386d55c8013fac3ae86599b2.png";